<template>
  <div class="contact">
    <mt-header title="我的联系人" class="reftitle">

      <mt-button slot="left" icon="back" @click="goback">返回</mt-button>

      <mt-button @click="createContact" slot="right">新建联系人</mt-button>
    </mt-header>
    <div class="contactspace"></div>
    <div v-for="(item, index) in list">
      <div class="contact-my-f1">
        <div class="contactflex1">
          <img class="contact-my-user" src="/static/img/contract/signer.png">
        </div>
        <div class="contactflex2 contact-ms" @click="viewContact(item)">
          <span class="contactName">姓名:&nbsp;&nbsp;{{item.name}}</span>
          <span class="contactheight">电话:&nbsp;&nbsp;{{item.mobile}}</span>
          <span class="contactheight">邮箱:&nbsp;&nbsp;{{item.mail}}</span>
        </div>
        <div class="contactflex3">
          <img class="contact-delete" @click="deleteContact(index,item)" src="/static/img/user/sign/delete.png">
        </div>
        <!--<img class="_delete_sign" @click="deleteSign(index,item)" src="/static/img/user/sign/delete.png"/>-->
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
  import {Toast, Actionsheet, Field, Indicator} from 'mint-ui';
  export default {
    data () {
      return {
        list: [],
        _selected: ''
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      viewContact: function (item) {
        this.$router.push({
          path: '/my/mycontact/editMyContact',
          name: 'editMyContact',
          query: {
            _selected: "tab-container3",
            _name: item.name,
            _mobile: item.mobile,
            _mail: item.mail,
            _id: item.id
          }
        })
      },
      deleteContact(index, item){
        //利用Ajax请求,重新获取签名数据
        var id = item.id;
        var _deleteContactsUrl = domain("_deleteContacts");
        var that = this;
        that.$http.post(
          _deleteContactsUrl,
          {id: id},
          {emulateJSON: true}
          )
          .then(function (response) {
            //接口返回数据
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              this.fetcchMsg();
            } else {
              Toast(msg)
            }

          }, function (error) {
            Toast(msg);
          }).catch(function (response) {
          //Toast("数据获取响应异常.");
        })
      },
      createContact: function () {
        this.$router.push({
          path: '/my/mycontact/addMyContact',
          name: 'addMyContact',
          query: {
            _selected: "tab-container3"
          }
        })
      },
      fetcchMsg: function () {
        var _queryMyContactsyncUrl = domain("_queryMyContactsync");
        var that = this;
        that.$http.post(
          _queryMyContactsyncUrl,
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              this.list = response.data.data.rows;
            } else {
              Toast(msg)
            }
          }, function (error) {
            console.log(error)
            Toast(msg)
          }).catch(function (response) {
          console.log(response)
          //Toast("数据获取响应异常.")
        })
      },
      initParams: function () {
        let params = this.$route.query;
        this._selected = params._selected;
      }
    },
    components: {},
    mounted: function () {
      this.fetcchMsg();
      this.initParams();
    }
  }
</script>
<style>
  .my-approval {
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #f9edd7;
  }
  .my-approval img {
    width: 14px;
    margin: 15px 15px 0 0;
  }
  .my-approval a {
    color: #1f74d8;
  }
  .my-approval span {
    color: #997a3d;
  }
  .my-approval a, .my-approval span {
    font-size: 1rem;
  }
  .contact-my-f1 {
    background-color: #ffffff;
    padding: 0 10px 10px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .contactflex1{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
  }
  .contactflex2{
    -webkit-box-flex: 3;
    -ms-flex: 3;
    flex: 3;
    text-align: left;
  }
  .contactflex3{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;
  }
  .contact-my-user {
    width: 40px;
    margin: 15px 0 0 0;
  }
  .contact-my-f1 .contact-ms {
    margin-top: 12px;
    font-size: 0.9rem;
    color: #7d7d7d;
  }
  .contact-delete {
    width: 18px;
    margin: 25px 10px 0 0;
  }
  .contact-my-f1 .rarrow {
    margin: 35px 0 0 0;
  }
  .contactspace {
    width: 100%;
    height: 15px;
    background-color: #f0f0f0;
  }
  .contactheight{
    display: block;
    word-break:break-all;
  }
  .contactName{
    display: block;
    word-break:break-all;
  }
</style>



// WEBPACK FOOTER //
// src/module/my/Mycontact.vue